export default "__VITE_ASSET__D$61Tnvm__"